module.exports = require("buffer");


//////////////////
// WEBPACK FOOTER
// external "buffer"
// module id = buffer
// module chunks = 5